import { environment } from 'env';

export interface MenuItem {
  id?: string;
  route: string | null;
  icon?: string;
  name: string;
  iconType?: 'font' | 'material';
  summary?: string;
  featureFlagName: keyof (typeof environment.featuresFlag);
  children?: MenuItem[];
  requiredPermissions: string[];
}

export const ALL_ITEMS: MenuItem[] = [
  {
    route: '/dashboard',
    icon: 'home',
    name: 'Home',
    featureFlagName: 'home',
    requiredPermissions: []
  },
  {
    route: '/deposit',
    icon: 'card-receive',
    name: 'Add Money',
    featureFlagName: 'deposit',
    requiredPermissions: ['my_wallet_generate_address']
  },
  {
    route: '/withdraw',
    icon: 'card-send',
    name: 'Send Money',
    featureFlagName: 'withdraw',
    requiredPermissions: ['my_wallet_send_money_create']
  },
  {
    route: '',
    icon: 'card-edit',
    iconType: 'material',
    name: 'Settlement',
    featureFlagName: 'settlement',
    requiredPermissions: [],
    children: [
      {
        route: '/new-settlement',
        name: 'New Settlement',
        featureFlagName: 'settlement',
        requiredPermissions: []
      },
      {
        route: '/settlement-history',
        name: 'Settlement History',
        featureFlagName: 'settlement',
        requiredPermissions: []
      },
    ]
  },
  {
    route: '/vouchers',
    icon: 'ticket',
    name: 'Vouchers List',
    featureFlagName: 'vouchers',
    requiredPermissions: ['my_vouchers_buy', 'my_vouchers_merge', 'my_vouchers_redeem', 'my_vouchers_split', 'my_vouchers_view']
  },
  {
    route: '/crypto-transactions',
    icon: 'empty-wallet-change',
    name: 'Crypto Transaction',
    featureFlagName: 'cryptoTransactions',
    requiredPermissions: ['my_crypto_transactions_details', 'my_crypto_transactions_export', 'my_crypto_transactions_view']
  },
  {
    route: '/balance-history',
    icon: 'dollar-square',
    name: 'Balance History',
    featureFlagName: 'balanceHistory',
    requiredPermissions: ['my_wallet_transactions_view', 'my_wallets_view', 'my_wallet_transaction_view']
  },
  {
    route: '/buy-voucher',
    icon: 'ticket-alt',
    name: 'Buy Voucher',
    featureFlagName: 'buyVoucher',
    requiredPermissions: ['my_vouchers_buy']
  },
  {
    route: '/redeem-voucher',
    icon: 'ticket-expired',
    name: 'Redeem Voucher',
    featureFlagName: 'redeemVoucher',
    requiredPermissions: ['my_vouchers_redeem']
  },
  {
    route: '/merge-voucher',
    icon: 'merge-voucher',
    name: 'Merge Voucher',
    featureFlagName: 'mergeVoucher',
    requiredPermissions: ['my_vouchers_merge']
  },
  {
    route: 'split-voucher',
    icon: 'split-voucher',
    name: 'Split Voucher',
    featureFlagName: 'splitVoucher',
    requiredPermissions: ['my_vouchers_split']
  },
  {
    route: '',
    icon: 'security-user',
    name: 'Account',
    featureFlagName: 'account',
    requiredPermissions: [],
    children: [
      {
        route: '/profile',
        name: 'Profile',
        featureFlagName: 'profile',
        requiredPermissions: []
      },
      {
        route: '/kyc',
        name: 'Identity Verification',
        featureFlagName: 'identityVerification',
        requiredPermissions: []
      },
      {
        route: '/security',
        name: 'Security',
        featureFlagName: 'security',
        requiredPermissions: []
      },
    ]
  },
  // {
  //   route: null,
  //   icon: 'logout-menu',
  //   name: 'Logout',
  //   featureFlagName: 'logout',
  //   requiredPermissions: []
  // },
];
